var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5722 9.32442L8.48076 7.75587V4.56069C8.48076 4.23942 8.22107 3.97974 7.8998 3.97974C7.57853 3.97974 7.31885 4.23942 7.31885 4.56069V8.04638C7.31885 8.22937 7.40483 8.40192 7.55123 8.51114L9.875 10.254C9.97528 10.3295 10.0974 10.3703 10.223 10.3702C10.4002 10.3702 10.5745 10.2906 10.6883 10.1372C10.8813 9.88098 10.829 9.51673 10.5722 9.32442Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8999 0.5C3.76415 0.5 0.399902 3.86425 0.399902 8C0.399902 12.1358 3.76415 15.5 7.8999 15.5C12.0357 15.5 15.3999 12.1358 15.3999 8C15.3999 3.86425 12.0357 0.5 7.8999 0.5ZM7.8999 14.3381C4.40552 14.3381 1.56179 11.4944 1.56179 8C1.56179 4.50562 4.40552 1.66188 7.8999 1.66188C11.3949 1.66188 14.238 4.50562 14.238 8C14.238 11.4944 11.3943 14.3381 7.8999 14.3381Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e35c22d6bb7af17b535ec94612e0c5bc.svg";
export { ForwardRef as ReactComponent };